import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
// Removed Redux imports
import NavBar from "./components/Navbar";
import Capitals from "./components/Capitals";
import Home from "./components/Home";

function App() {
  // Removed store configuration

  return (
    <>
      <title>Geography Dash</title>
      {/* Removed Provider */}
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/capitals" element={<Capitals />} />
        </Routes>
      </BrowserRouter>
      {/* Removed Provider */}
    </>
  );
}

export default App;
